export const FBC_PARAM = '_fbc';
export const FBP_PARAM = '_fbp';

export const FB_PIXEL_ID = '803693236922285';
